import { createSelector } from 'reselect';

const getFirstLoad = (state) => state.impersonate.isFirstLoad;
const getImpersonated = (state) => state.impersonate.impersonated;
const getImpersonatedUser = (state) => state.impersonate.impersonatedUser;

export const getFirstLoadSelector = createSelector(getFirstLoad, (isFirstLoad) => isFirstLoad);
export const getIsImpersonatedSelector = createSelector(getImpersonated, (impersonated) => impersonated);
export const getImpersonatedUserSelector = createSelector(getImpersonatedUser, (impersonatedUser) => impersonatedUser);
